import Moment from 'moment';


export function timestampToString(milis, format='MMMM, D YYYY'){
    return Moment(new Date(milis * 1000)).format(format);
}

export function datetimeToString(datetime, format='MMMM D, YYYY', as_utc=false){    
    if(as_utc){
      return Moment.utc(datetime).format(format);
    }else{
      return Moment(datetime).format(format);
    } 
}

export function timeStringTodatetime(time, format="h:mm:ss", as_utc=false){
  if(as_utc){
    return Moment.utc(time, format);
  }else{
    return Moment(time, format);
  }  
}


/* Return hours in a day: 01:00 Am ... */
export function timeDay(){  
  const hoursPerDay = 24;
  let time = [];
  let formattedTime;
  for(let i =0; i < hoursPerDay ; i++){
      formattedTime = (Moment().set({m: 0}).subtract(i, "hours")).format("hh:mm A");  //give the time in format X AM/PM
      time.unshift(formattedTime);  //add to beginning of array
  }  //do this for all 24 hours
  return time;                              
}

export function daysOfWeek(){
  return Moment().localeData('en-us').weekdays();
}